export default function newsCarousel(card) {
    const cardSlick = $(card);

    const responsive = [
        {
            breakpoint: 900,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                variableWidth : false,
                arrows: true,


            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                variableWidth : false,

            }
        },
    ]

    const settings = {
        infinite: false,
        lazyLoad: 'ondemand',
        slidesToShow: 2,
        slidesToScroll: 2,
        centerMode: false,
        variableWidth : true,
        dots: false,
        prevArrow: $('.news-navigation__prev'),
        nextArrow: $('.news-navigation__next'),
        responsive,
    }

    cardSlick.slick(settings);

    cardSlick.on('breakpoint', function() {
        const events = document.querySelectorAll('[data-bg]');

        for (let event of events) {
            var bg = event.getAttribute('data-bg');

            if (bg) event.style.backgroundImage = 'url(' + bg + ')';
        }
    });

}

document.addEventListener('readystatechange', () => {


        const list = document.querySelectorAll('.news__cards');

        for (let card of list) {
            newsCarousel(card);
    }
});
